(function () {
  // Scoped to a single .faq-accordion__list so multiple independent
  // accordion groups (e.g. one per FAQ category) can coexist in one section
  // without "close other open items" reaching across group boundaries.
  const initFaqAccordion = (list) => {
    const items = list.querySelectorAll(".faq-accordion__item");

    if (!items.length) return;

    function setInitialState(item) {
      const answer = item.querySelector(".faq-accordion__answer");
      if (!answer) return;

      answer.style.transition = "none";

      if (item.classList.contains("active")) {
        answer.style.display = "block";
        answer.style.height = "auto";
      } else {
        answer.style.display = "block";
        answer.style.height = "0px";
      }

      requestAnimationFrame(() => {
        answer.style.removeProperty("transition");
      });
    }

    function openItem(item) {
      const answer = item.querySelector(".faq-accordion__answer");
      const toggle = item.querySelector(".faq-accordion__question");
      if (!answer) return;

      item.classList.add("active");
      if (toggle) toggle.setAttribute("aria-expanded", "true");

      answer.style.display = "block";
      answer.style.height = answer.scrollHeight + "px";

      const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        if (item.classList.contains("active")) {
          answer.style.height = "auto";
        }
        answer.removeEventListener("transitionend", onEnd);
      };

      answer.addEventListener("transitionend", onEnd);
    }

    function closeItem(item) {
      const answer = item.querySelector(".faq-accordion__answer");
      const toggle = item.querySelector(".faq-accordion__question");
      if (!answer) return;

      answer.style.height = answer.scrollHeight + "px";
      answer.offsetHeight;

      item.classList.remove("active");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      answer.style.height = "0px";
    }

    function toggleItem(item) {
      const isOpen = item.classList.contains("active");

      items.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains("active")) {
          closeItem(otherItem);
        }
      });

      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    }

    items.forEach((item) => {
      const toggle = item.querySelector(".faq-accordion__question");

      setInitialState(item);

      if (!toggle) return;

      toggle.addEventListener("click", () => {
        toggleItem(item);
      });

      toggle.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          toggleItem(item);
        }
      });
    });

    window.addEventListener("resize", () => {
      items.forEach((item) => {
        if (!item.classList.contains("active")) return;
        const answer = item.querySelector(".faq-accordion__answer");
        if (answer) answer.style.height = "auto";
      });
    });
  };

  const initAllFaqAccordions = (root) => {
    root.querySelectorAll(".faq-accordion__list").forEach(initFaqAccordion);
  };

  initAllFaqAccordions(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAllFaqAccordions(event.target);
  });
})();
